import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconGutterHorizontal12 from './IconGutterHorizontal12';
import IconGutterHorizontal16 from './IconGutterHorizontal16';
import IconGutterHorizontal20 from './IconGutterHorizontal20';
import IconGutterHorizontal24 from './IconGutterHorizontal24';
import IconGutterHorizontal32 from './IconGutterHorizontal32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconGutterHorizontal = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconGutterHorizontal12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconGutterHorizontal16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconGutterHorizontal20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconGutterHorizontal24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconGutterHorizontal32 {...props} />}
        </span>
    );
};
IconGutterHorizontal.displayName = 'FondueIconGutterHorizontal';

export default memo(IconGutterHorizontal);
